<template>
	<div class="section-our-plans" id="plans">
		<div class="container">
			<h3 class="section-our-plans-title mb-5">NUESTROS PLANES</h3>
			<div v-if="code === 'PE'">
				<v-layout wrap>
					<v-flex v-for="item in items" :key="item.id" md4 xs12>
						<div class="section-our-plans-container">
							<div v-if="item.showAlert" class="text-alert">
								RECOMENDADO
							</div>
							<div class="h-40"></div>
							<p class="mb-2 text-title">{{ item.title }}</p>
							<p class="mb-2 text-number">{{ item.text }}</p>
							<p class="mb-2 subtext">{{ item.subtext }}</p>
							<div class="text-xs-center">
								<button class="section-our-plans-btn-mobile" @click="openPlanMobile(item)">Ver detalle</button>
							</div>
						</div>
					</v-flex>
				</v-layout>
				<div class="text-xs-center">
					<a 
						class="section-our-plans-btn" 
						href="https://mibodega.s3-sa-east-1.amazonaws.com/planes-casa-market-nuevo.pdf"
						target="_blank"
						>VER DETALLE</a>
				</div>
			</div>
			<div v-else>
				<v-layout wrap justify-center>
					<v-flex v-for="item in itemsEcu" :key="item.id" md4 xs12>
						<div class="section-our-plans-container">
							<div class="h-40"></div>
							<p class="mb-2 text-title">{{ item.title }}</p>
							<p class="mb-2 text-number">{{ item.text }}</p>
							<p class="mb-2 subtext">{{ item.subtext }}</p>
							<p class="mb-2 subtext">{{ item.textInformation }}</p>
						</div>
					</v-flex>
				</v-layout>
			</div>
		</div>
		<v-dialog
			v-model="dialog"
			max-width="90%"
		>
				<div class="container-image-plan">
					<v-btn
						depressed
						flat
						icon
						class="image-plan-btn"
						@click="closeModal"
					>
							<img src="/static/images/sections/close-white.svg" alt="cerrar" height="20">
					</v-btn>
					<img 
						:src="urlImage" 
						alt="planes"
						class="image-plan">
				</div>
		</v-dialog>
	</div>
</template>
<script>

function openPlanDesktop() {
	this.urlImage = '/static/images/sections/plan-desktop.png';
	this.dialog = true;
}

function openPlanMobile({ urlImage }) {
	this.urlImage = urlImage;
	this.dialog = true;
}

function closeModal() {
	this.dialog = false;
}

function data() {
	return {
		items: [
			{
				id: 1,
				title: 'Plan Promocional',
				text: 'S/500.00',
				subtext: 'Licencia + Implementación',
				showAlert: false,
				urlImage: '/static/images/sections/plan-1.png',
			},
			{
				id: 2,
				title: 'Plan básico',
				text: 'S/799.00',
				subtext: 'Licencia + Implementación',
				showAlert: false,
				urlImage: '/static/images/sections/plan-2.png',
			},
			{
				id: 3,
				title: 'Plan Full',
				text: 'S/1,200.00',
				subtext: 'Licencia + Implementación',
				showAlert: true,
				urlImage: '/static/images/sections/plan-3.png',
			},
			{
				id: 4,
				title: 'Plan MEGA',
				text: 'S/2,200.00',
				subtext: 'Licencia + Implementación',
				showAlert: false,
				urlImage: '/static/images/sections/plan-4.png',
			},
			{
				id: 5,
				title: 'Plan MultiComercio',
				text: 'S/1,800.00',
				subtext: 'Licencia + Implementación',
				showAlert: false,
				urlImage: '/static/images/sections/plan-5.png',
			},
			{
				id: 6,
				title: 'Plan MultiComercio Full',
				text: 'S/2,500.00',
				subtext: 'Licencia + Implementación',
				showAlert: true,
				urlImage: '/static/images/sections/plan-6.png',
			},
		],
		itemsEcu: [
			{
				id: 1,
				title: 'Plan Promocional',
				text: '$150',
				subtext: 'Licencia + Implementación',
				textInformation: 'Mensualidades de $8',
			},
		],
		dialog: false,
		urlImage: '',
	};
}
export default {
	name: 'section-our-plans',
	data,
	methods: {
		closeModal,
		openPlanDesktop,
		openPlanMobile,
	},
	props: {
		code: String,
	},
};
</script>
<style lang="scss">
	.section-our-plans {
		background: color(blue-l);
		padding: 80px 10%;

		&-title {
			color: color(secondary);
			font-size: size(large30);
			font-weight: 900;
			text-align: center;
		}

		&-container {
			background: color(secondary);
			border-radius: 17px;
			color: color(white);
			font-size: size(medium16);
			margin: 0 auto 35px auto;
			max-width: 288px;
			padding: 0 0 40px 0;
			position: relative;
			text-align: center;
			width: 90%;
		}

		&-btn {
			background: color(primary-cs);
			border-radius: 8px;
			color: color(white);
			display: inline-block;
			font-size: size(medium20);
			font-weight: 900;
			padding: 18px 0;
			text-decoration: none;
			width: 259px;

			@media (max-width: 960px) {
				display: none;
			}
		}

		&-btn-mobile {
			background: color(primary-cs);
			border-radius: 5px;
			display: none;
			color: color(white);
			font-size: size(medium);
			font-weight: 900;
			padding: 7px 18px;

			@media (max-width: 960px) {
				display: inline-block;
			}
		}

		.text-title {
			font-weight: 600;
			text-transform: uppercase;
		}

		.text-number {
			font-size: size(large26);
			font-weight: 900;
		}

		.subtext {
			font-size: size(medium18);
			font-weight: 600;
		}

		.text-alert {
			background: color(primary-cs);
			border-radius: 0 17px 0 17px;
			font-size: size(small);
			padding: 8px;
			position: absolute;
			top: 0;
			right: 0;
		}

		.h-40 {
			height: 40px;
		}
	}

	.image-plan {
		max-width: 100%;
	}

	.dialog {
		box-shadow: none !important;
	}

	.container-image-plan {
		position: relative;
	}

	.image-plan-btn {
		position: absolute;
		right: 10px;
		top: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-our-plans.vue